import { Typography, IconButton, Box, Tooltip } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
const PreviewPanel = ({
  json,
  onRefresh,
  title,
}: {
  json: string;
  onRefresh?: () => void;
  title?: string;
}) => {
  const lines = json.split("\n");

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        <Typography variant="h6" sx={{ fontSize: 20, flex: 1, mb: 2 }}>
          {title}
        </Typography>
        <Tooltip title="Refresh preview">
          <IconButton
            size="small"
            onClick={onRefresh}
            sx={{
              color: "#9c27b0", // purple like screenshot
              ml: 1,
            }}
          >
            <RefreshIcon />
          </IconButton>
        </Tooltip>
      </Box>

      {/* <Typography variant="caption" color="text.secondary" sx={{ mb: 1 }}>
        Request SQL
      </Typography> */}

      <Box
        sx={{
          borderRadius: 1,
          border: "1px solid rgba(0,0,0,0.12)",
          overflow: "hidden",
          background: "#fff",
          maxHeight: 340,
          boxShadow: "none",
        }}
      >
        <Box
          sx={{
            display: "flex",
            background: "#f9f9f9",
            borderBottom: "1px solid rgba(0,0,0,0.04)",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary" />
        </Box>

        <Box
          sx={{
            display: "flex",
            fontFamily: "monospace",
            fontSize: "12px",
            lineHeight: 1.5,
            color: "text.primary",
            maxHeight: 300,
            overflow: "auto",
          }}
        >
          {/* gutter (line numbers) */}
          <Box
            sx={{
              background: "#fafafa",
              borderRight: "1px solid rgba(0,0,0,0.04)",
              px: 1.25,
              py: 1,
              textAlign: "right",
              userSelect: "none",
              color: "rgba(0,0,0,0.5)",
            }}
          >
            <pre style={{ margin: 0 }}>
              {lines.map((_, idx) => (
                <div key={idx} style={{ height: "2em" }}>
                  {idx + 1}
                </div>
              ))}
            </pre>
          </Box>

          {/* code content */}
          <Box sx={{ p: 1, flex: 1 }}>
            <pre
              style={{
                margin: 0,
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                fontSize: 16,
                fontFamily: "roboto",
                minHeight: "600px",
              }}
            >
              {json}
            </pre>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PreviewPanel;
